import type { ReactNode } from "react";
import classNames from "classnames";

import Icon from "@/components/Icon";
import type { MaterialNames } from "@/components/material_symbol_names";

const DASH_ARRAY = "10 6";

export type PlaceholderCardProps = {
  title: string;
  caption?: string;
  iconName?: MaterialNames;
  className?: string;
  testId?: string;
  children?: ReactNode;
};

export default function PlaceholderCard({
  title,
  caption,
  iconName,
  className,
  testId = "placeholder-card",
  children
}: PlaceholderCardProps) {
  return (
    <div
      role={children ? undefined : "status"}
      className={classNames("relative w-full overflow-hidden rounded-xl p-8 text-center", className)}
      data-testid={testId}
    >
      <svg
        className="pointer-events-none absolute inset-0 h-full w-full text-sys-brand-outline-variant"
        aria-hidden="true"
      >
        <rect
          x="1"
          y="1"
          width="calc(100% - 2px)"
          height="calc(100% - 2px)"
          rx="11"
          ry="11"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeDasharray={DASH_ARRAY}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      {iconName && <Icon name={iconName} size={48} className="mx-auto mb-3 text-sys-brand-on-surface-variant" />}
      <p className="text-body-medium text-sys-brand-on-surface m-0">{title}</p>
      {caption && <p className="text-body-small text-sys-brand-on-surface-variant m-0 mt-1">{caption}</p>}
      {children && <div className="mt-4 flex justify-center">{children}</div>}
    </div>
  );
}
